<template>
    <div>
        <vue-ueditor-wrap :config="myConfig" v-model="content" @ready="ready"></vue-ueditor-wrap>
    </div>
</template>

<script>
    import VueUeditorWrap from 'vue-ueditor-wrap';
    import userInfoHelper from '../common/userInfo';

    export default {
        name: "elUeditor",
        components:{VueUeditorWrap},
        props:['value'],
        data () {
            return {
                content: '',
                myConfig: {
                    // 编辑器不自动被内容撑高
                    autoHeightEnabled: false,
                    // 工具栏是否可以浮动
                    autoFloatEnabled: false,
                    // 关闭自动保存
                    enableAutoSave: true,
                    // 初始容器高度
                    initialFrameHeight: 400,
                    // 初始容器宽度
                    initialFrameWidth: '100%',
                    // 上传文件接口
                    serverUrl: 'admin/ueditor/upload?Authorization=' + userInfoHelper.get().accessToken,
                    // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
                    UEDITOR_HOME_URL: '/ueditor/',
                }
            }
        },
        watch:{
            value(val) {
                this.content = val;
            },
            content(val) {
                this.$emit('change', val);
            }
        },
        mounted() {
            this.content = this.value;
        },
        methods:{
            ready(editorInstance){
            }
        }
    }
</script>

<style scoped>

</style>